export const FRAMEWORKS = {
  REACT: 'React',
  VUE: 'Vue',
  ANGULAR: 'Angular',
  EMBER: 'Ember',

  SYMFONY: 'Symfony',
  LARAVEL: 'Laravel',
  NODEJS: 'Node.js'
}



// WEBPACK FOOTER //
// ./src/config/developers/frameworks.js